import * as Redux from 'redux'
import * as Router from '../../../router'
import * as Constants from './constants'
import * as Types from './types'

export const EmptyState: Types.NavState = {
  activeMenu: '',
  isMenuOpen: false,
  menuState: {},
  navItems: Constants.navItems,
}

interface ToggleSubNavMobileAction extends Redux.Action { href: Types.Href }

export const reducer = (
  state: Types.NavState = EmptyState,
  action: Redux.Action & ToggleSubNavMobileAction,
) => {
  switch (action.type) {
    case Router.LOCATION_CHANGE:
      return EmptyState
    case Constants.TOGGLE_MAIN_MENU_MOBILE:
      return {
        ...state,
        isMenuOpen: !state.isMenuOpen,
      }
    case Constants.TOGGLE_SUBNAV_MOBILE:
      const updatedItems = state.navItems.map((item: Types.NavItem) => item.href === action.href ?
       {...item, isOpen: !item.isOpen} : {...item})
      return {
        ...state,
        navItems: updatedItems,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/menu/left-nav/reducer.ts